import React from 'react';
import PropTypes from 'prop-types';
//import Link from 'components/Link';
import Image from 'components/Image';
import Video from 'components/Video/VideoLoader';
import s from './LeadImageVideo.scss';

const LeadImageVideo = props => {
  const { msid, title, imageData: { imagesize }, slikeId = '' } = props;
  if (!msid) {
    return null;
  }
  return (
    <div className={s.imageWrapper}>
      <div className={s.content}>
        {!slikeId ? (
          <Image
            key={msid}
            msid={msid}
            width={400}
            placeHolderSrc="https://static.toiimg.com/photo/msid-25581306/25581306.jpg"
            altTitle={title}
            imgsize={imagesize}
            lazyload={false}
            decoding="async"
            //onError={customOnError}
          />
        ) : (
          <Video
            key={msid}
            msid={msid}
            slikeId={slikeId}
            alt={title}
            width={400}
            imgsize={imagesize}
            livetv
            videoClassName={`${s.leadVideo}`}
            iconClassName={s.VideoIcon_duration}
            videoClassInner={`${s.content}`}
            tmplSource='videoshow'
          />
        )}
      </div>
    </div>
  );
};

LeadImageVideo.propTypes = {
  title: PropTypes.string,
  msid: PropTypes.string.isRequired,
  imageData: PropTypes.shape({}),
  slikeId: PropTypes.string,
};

LeadImageVideo.defaultProps = {
  title: '',
  imageData: {},
  slikeId: '',
};

export default LeadImageVideo;
